function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  transform: "translate(-22.5 -20.25)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12.8,
  height: 22.4,
  rx: 2.25,
  transform: "translate(40.1 47.45)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 12.8,
  height: 12.8,
  rx: 2.25,
  transform: "translate(22.5 57.05)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 12.8,
  height: 32,
  rx: 2.25,
  transform: "translate(57.7 37.85)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.935 37.615a.8.8 0 001.131 0l7.435-7.435 7.435 7.435a.8.8 0 001.131 0L61.7 22.981v7.669a.8.8 0 001.6 0v-9.6a.836.836 0 00-.06-.306.811.811 0 00-.434-.434.836.836 0 00-.306-.06h-9.6a.8.8 0 100 1.6h7.669L46.5 35.919l-7.435-7.435a.8.8 0 00-1.131 0l-8 8a.8.8 0 00.001 1.131z"
}));

function SvgNumbers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49.6,
    viewBox: "0 0 48 49.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbers);
export default __webpack_public_path__ + "static/media/numbers.d0e02075.svg";
export { ForwardRef as ReactComponent };